import { toast } from "react-toastify";

const toastMeta = {
    success: {
        icon: "bx-check-circle",
        fallbackTitle: "Operation reussie"
    },
    error: {
        icon: "bx-error-circle",
        fallbackTitle: "Erreur"
    },
    warning: {
        icon: "bx-error",
        fallbackTitle: "Attention"
    },
    info: {
        icon: "bx-info-circle",
        fallbackTitle: "Information"
    }
};

export const showToast = ({
                              title,
                              message = "",
                              type = "success",
                              duration = 3000
                          }) => {
    const normalizedType = toastMeta[type] ? type : "success";
    const meta = toastMeta[normalizedType];

    toast(
        <div className="soma-toast-content">
            <span className="soma-toast-icon" aria-hidden="true">
                <i className={`bx ${meta.icon}`} />
            </span>
            <span className="soma-toast-copy">
                <strong>{title || meta.fallbackTitle}</strong>
                {message && <span>{message}</span>}
            </span>
        </div>,
        {
            type: normalizedType,
            autoClose: duration,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            position: "bottom-right",
            icon: false,
            className: `soma-toast soma-toast-${normalizedType}`
        }
    );
};
